<frmg-main-vertical-menubar-left
  [showNotification]="showNotification"
  (showNotificationChange)="showNotificationChange($event)"
  [totalUnreadNotifications]="totalUnreadNotifications"
  >

</frmg-main-vertical-menubar-left>


@if (showNotification) {
  <frmg-notification-list [notificationList]="notificationsArray"
  (hideNotificationsEmitter)="hideNotification()"></frmg-notification-list>
  <div class="overlay" (click)="hideNotification()"></div>
}


<!-- -->
<router-outlet></router-outlet>

@if (newNotifications().length) {
  <div class="notification-container ">
    @if (newNotifications().length > 1) {
      <div class="dismiss-btn" (click)="dismissAll()">
        <span>Dismiss All</span></div>
      }
      <div [ngClass]="{'cascade' : newNotifications().length > 3}">
        @for (popUp of newNotifications(); track popUp) {
          @if (!popUp.read) {
            <div class="notification-element">
              <div>
                <div class="notification-icon">
                  <div class="notification-type" [innerHTML]="getCategoryType(popUp)"></div>
                  <div class="notification-sub-category">
                    <span [ngClass]="getSubCategoryType(popUp)"></span>
                  </div>
                </div>
                <div class="notification-body" [innerHTML]="notificationMsgTransform(popUp.message)"></div>
                <div class="notification-action icon icon-small-close" (click)="dismissNotification(popUp)"></div>
              </div>
              @if (newNotifications().length > 3 && $index == 0) {
                <div class="notification-more"
                  >{{ newNotifications().length - 1 }}
                  more notifications
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }

  @if (notificationService.DownloadsArray.length) {
    <div class="notification-container ">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="downloads-title">Downloading files ({{notificationService.DownloadsArray.length}}) </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="horizontal-separator"></div>
          @for (popUp of notificationService.DownloadsArray; track popUp) {
            <div class="download-element">
              <div class="download-title">
                <div>{{popUp.fileName}}</div>
                @if (popUp.total !== 0) {
                  <div>{{popUp.percentage}}%</div>
                }
              </div>
              <mat-progress-bar [value]="popUp.percentage" [mode]="barType(popUp)"></mat-progress-bar>
              <div class="download-info">
                <div>Downloading...</div>
                @if (popUp.total !== 0) {
                  <div> <span >{{(popUp.loaded/1000).toFixed(2)}} KB</span> / <span>{{(popUp.total/1000).toFixed(2)}} KB</span></div>
                }
              </div>
            </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }